module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic13.c3b7000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic13.png
// module id = 580
// module chunks = 1